import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { DeviceState } from 'console/shared/contexts/device/state/types';
import { get_z3k_object_state, GuardZone } from 'z3k-config';
import * as S from './styles';
import { GuardZoneSensors } from './components/guard-sensors';
import { GuardZoneHeader } from './components/header';
import { send_z3k_command } from 'z3k-settings/redux/actions';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import { useZ3KDeviceState } from 'console/shared/hooks/device/z3k';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
export const GuardZoneCard = memo(function GuardCard(props) {
    const { guard_zone } = props;
    const { id, name, sensors } = guard_zone;
    const { device_id } = useContext(DeviceConfig);
    const { online } = useContext(DeviceState);
    const z3k_state = useZ3KDeviceState();
    const { loading, fail, fail_message } = useAppSelector((state) => {
        return {
            loading: state.z3k_settings?.action_state?.[device_id]?.[id]?.loading,
            fail: state.z3k_settings?.action_state?.[device_id]?.[id]?.fail,
            fail_message: state.z3k_settings?.action_state?.[device_id]?.[id]?.fail_message,
        };
    });
    const guard_zone_state = useMemo(() => {
        const zone_state = get_z3k_object_state(z3k_state, id);
        if (!zone_state) {
            return { on_guard: false, is_turn_on: false, is_turn_off: false };
        }
        return {
            on_guard: GuardZone.isOnGuard(zone_state),
            is_turn_off: GuardZone.isTurnedOff(zone_state),
            is_turn_on: GuardZone.isTurnedOn(zone_state),
        };
    }, [z3k_state, id]);
    const { on_guard, is_turn_on, is_turn_off } = guard_zone_state;
    const sendZ3KCommand = useAction(send_z3k_command);
    const disabled_guard = useMemo(() => !online || (is_turn_on && !on_guard) || (is_turn_off && on_guard), [online, is_turn_on, is_turn_off, on_guard]);
    const onSetGuard = useCallback((zone_on_guard) => {
        sendZ3KCommand(device_id, id, 'ZoneOnGuard', { onguard: zone_on_guard }, null, false);
    }, [device_id, id]);
    return (_jsxs(S.GuardZoneCard, { "data-tooltip": "guard-zone-card", children: [_jsx(GuardZoneHeader, { id: id, on_guard: on_guard, name: name, disabled_guard: disabled_guard, loading: loading, onSetGuard: onSetGuard, fail: fail, fail_message: fail_message }), _jsx(GuardZoneSensors, { sensors_config: sensors })] }));
});
